// @flow

import React, { type Node } from 'react';
import { TipsBox } from '@tectonics/look-and-feel/shopify/commons/organisms/tips-box';
import phoneTipSrc from './phone-tip.svg';
import printTipSrc from './print-tip.svg';

export function PaynetTipsBox(): Node {
  return (
    <TipsBox title="Consejos de pago!" tipsModel={[
      {
        imgSrc: printTipSrc,
        altText: 'print icon',
        tipText: 'Después de realizar tu pago, verifica que en el comprobante emitido por el cajero esté escrito “PAYNET SERVICIO”.',
      },
      {
        imgSrc: phoneTipSrc,
        altText: 'smartphone confirmation icon',
        tipText: 'La confirmación se realizará instantes después de completar el pago.',
      },
    ]}
    />
  );
}
